import { useIntercom } from '@backmarket/nuxt-layer-care-platform/intercom/composables/useIntercom'

export async function loadIntercom() {
  const { load, status } = useIntercom()

  if (status.value !== 'loaded') {
    return load()
  }

  return Promise.resolve()
}
